<template>
  <header>
    <h1>Daniel Burke</h1> 
    <span class="pages"><span id="selected_page">who?</span></span>
  </header>
</template>

<script>
export default {
  name: 'my-header'
}
</script>

<style scoped>
header {
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%
}

h1 {
    font-family: Helvetica, sans-serif;
}

.pages {
  font-size: 24pt;
  text-align: right;
  flex-grow: 1
}

#selected_page {
  color:firebrick;
}

</style>